import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { BookingStatus } from '@enums/BookingStatus.enum';
import { PageName } from '@enums/PageName.enum';
import { BookingFlowService } from '@services/abstract/booking-flow.service';
import { BookingObjectService } from '@services/booking-object.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { CountryInfoService } from '@services/country-info.service';
import { ErrorMessagesService } from '@services/error-messages.service';
import { MarketService } from '@services/market.service';
import { PostBookingFlowService } from '@services/post-booking-flow.service';
import { parseSearch } from '@utils/Navigation/parseSearch.utils';
import { redirectTo } from '@utils/Navigation/redirectTo.utils';
import { PagePaths } from '@values/Navigation/PagePaths.value';
import { TypeConstants } from '@values/Booking/TypeConstants.value';
import { AbstractBaseBookingStepComponent } from './abstract-base-booking-step.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BookingModalConfirmationLetterComponent } from '../booking-modal-confirmation-letter/booking-modal-confirmation-letter.component';
import { BookingSearch } from '@values/Booking/BookingSearch.value';

@Component({
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class AbstractBasePostBookingComponent extends AbstractBaseBookingStepComponent implements OnInit {
  protected readonly _marketService = inject(MarketService);
  protected readonly _postBookingFlowService = inject(PostBookingFlowService);
  protected readonly _bookingFlowService = inject(BookingFlowService);
  protected readonly _errorMessagesService = inject(ErrorMessagesService);
  protected readonly _bookingObjectService = inject(BookingObjectService);
  protected readonly _breadcrumbsService = inject(BreadcrumbService);
  protected readonly _countriesInfoService = inject(CountryInfoService);
  protected readonly _ngbModalService = inject(NgbModal);

  public isBookingConfirmed = null;
  public isDisabledDeposit = null;
  public hasAdditionalInfo: boolean = null;
  public hasNetiEnabled = null;
  public hasGiftCardEnabled = null;
  public isTRAVELAG = null;
  public ChangeBookingByElectronicChannel = null;
  public AirRemarks;
  public CruiseRemarks;

  public readonly ROLLBED_AND_BABYCOT_ALERT = 1;
  public readonly ROLLBED_ALERT = 2;
  public readonly BABYCOT_ALERT = 3;

  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.isDisabledDeposit = this._marketService.hasDisableDepositDisabledMarkets();
  }

  public requestBooking(pageName) {
    this.initialiseBookingStep(pageName, this.bookingInitialiser.bind(this));
  }

  public confirmationLetter() {
    this._ngbModalService.open(BookingModalConfirmationLetterComponent, { animation: true, size: 'md' });
  }

  protected bookingInitialiser() {
    //TODO: spostare parseSearch in una factory
    const bookingNumber = parseSearch()?.['bookingNumber'] ?? '';
    const friendsBookingNumber = parseSearch()?.['friendsBookingNumber'] ?? '';
    this._postBookingFlowService.displayBooking(
      this.onDisplayBookingSuccess.bind(this),
      this.onDisplayBookingError.bind(this),
      bookingNumber,
      friendsBookingNumber,
    );
  }

  protected onDisplayBookingError(err) {
    this._errorMessagesService.showErrorAlert(err).then(() => {
      this.goToSearchBooking();
    });
  }

  private goToSearchBooking() {
    redirectTo(PagePaths.searchBookings);
  }

  private getAirAndCruiseRemarks() {
    this.AirRemarks = this._bookingObjectService.getCurrentCruiseFromBookingObject()?.Itinerary?.AirRemarks;
    this.CruiseRemarks = this._bookingObjectService.getCurrentCruiseFromBookingObject()?.Itinerary?.CruiseRemarks;
  }

  protected onDisplayBookingSuccess() {
    try {
      //TODO: rimuovere questo broadcast asap!
      this._bookingObjectService.bookingObjectUpdate$.next();

      this.hasAdditionalInfo = this._marketService.hasAdditionalInfoEnabled();

      this.getAirAndCruiseRemarks();

      this.isBookingConfirmed = this._bookingObjectService.getCurrentBookingStatus() == BookingStatus.BOOKED;
      this.hasNetiEnabled =
        this._marketService.hasNetiEnabled() &&
        !this.isBookingConfirmed &&
        this._bookingObjectService.getCurrentBookingObject().NetInvoice.Agency;

      this.hasGiftCardEnabled = this._marketService.hasGiftCardEnabled() && this.isBookingConfirmed;

      if (this._breadcrumbsService.currentStep == PageName.PAGE6_EDIT) {
        const bo = this._bookingObjectService.getCurrentBookingObject();
        this.hasGiftCardEnabled = this.hasGiftCardEnabled && bo.PaymentInfo.PaymentDetails.DueAmount > 0;
      }

      this.isTRAVELAG = this._bookingObjectService.getCurrentBookingObject()?.Fare?.Code == TypeConstants.TRAVELAGENT_FARE;
      this.ChangeBookingByElectronicChannel = this._bookingObjectService.getCurrentBookingObject().ChangeBookingByElectronicChannel;
      this._countriesInfoService.retrieveAllCountriesInfo();
      this._allowedOperationService.retrieveAllowedOperationForBooking();

      this.setFunnelReferral(TypeConstants.FUNNEL_BOOKINGEDIT);

      this._costaBackendApiService
        .getWebCheckInUrl()
        .then((res) => {
          this.webCheckInUrl = res;
        })
        .catch((err) => {
          console.error('webCheckIn', err);
        });
    } catch (e) {
      console.warn('catched error', e);
    }
  }
}
